// Chinese (Traditional) — zh-Hant
export default {
  // --- Shell / nav ---
  app_name: '潮汐在身邊',
  search_stations: '搜尋站點',
  search_stations_hint: '搜尋站點 (⌘K)',
  settings: '設定',
  app_store: '在 App Store 下載',
  google_play: '在 Google Play 取得',
  app_promo_title: '下載免費應用程式，速度更快 🙂',
  app_promo_body: '同樣的潮汐與潮流預報，就在手機上。',
  privacy: '隱私',
  terms: '條款',
  data_sources: '資料來源',
  support: '支援',

  guides: '指南',
  // --- Home ---
  home_title: '尋找附近的潮汐和海流',
  by_country: '依國家／地區',
  favorite_tides: '喜愛潮汐',
  recent_tides: '最近潮汐',
  nearby_tides: '附近潮汐',
  favorite_currents: '喜愛海流',
  recent_currents: '最近海流',
  nearby_currents: '附近海流',
  favorite_charts: '喜愛海圖',
  recent_charts: '最近海圖',
  nearby_charts: '附近海圖',
  finding_stations: '正在尋找您附近的站點…',
  distance_away: '距離 {{distance}}',

  // --- Search overlay ---
  search_placeholder: '搜尋站點…',
  tide_stations: '驗潮站',
  current_stations: '潮位站',
  recents: '最近記錄',
  search_unavailable: '搜尋目前無法使用。',
  no_stations_found: '找不到站點。',
  search_prompt: '依名稱搜尋潮汐和海流站。',

  // --- Settings ---
  appearance: '外觀',
  appearance_system: '跟隨系統',
  appearance_light: '淺色',
  appearance_dark: '深色',
  tide_height: '潮汐高度',
  unit_feet: '呎',
  unit_meters: '公尺',
  distance: '距離',
  unit_miles: '哩',
  unit_kilometers: '公里',
  recent_stations: '最近的站點',
  clear_recents: '清除最近記錄',
  currents: '海流',
  nautical_charts: '海圖',
  browse_by_country: '依國家／地區瀏覽',
  countries_auto: '自動',
  countries_always: '一律顯示',
  countries_never: '不顯示',
  show: '顯示',
  hide: '隱藏',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}} 潮汐',
  current_title: '{{name}} 海流',
  last_tide: '上次潮汐',
  next_tide: '下次潮汐',
  coefficient: 'Coef',
  last_current: '上次海流',
  next_current: '下次海流',
  following_current: '下下次海流',
  high: '滿',
  low: '乾',
  tides: '潮汐',
  sun: '太陽',
  moon: '月亮',
  sunrise_now: '日出',
  sunset_now: '日落',
  moonrise_now: '月出',
  moonset_now: '月落',
  sunrise_week: '日出',
  sunset_week: '日落',
  moonrise_week: '月出',
  moonset_week: '月落',
  add_to_favorites: '加入收藏',
  remove_from_favorites: '從收藏中移除',

  // --- Week table dates ---
  today: '今天',
  tomorrow: '明天',

  // --- Moon phases ---
  phase_new_moon: '新月',
  phase_waxing_crescent: '娥眉月',
  phase_first_quarter: '上弦月',
  phase_waxing_gibbous: '盈凸月',
  phase_full_moon: '滿月',
  phase_waning_gibbous: '虧凸月',
  phase_last_quarter: '下弦月',
  phase_waning_crescent: '殘月',

  // --- Tide / current status vocabulary ---
  rising: '上漲中',
  falling: '下降中',
  high_tide: '高潮',
  low_tide: '低潮',
  ebb: '退潮',
  flood: '漲潮',
  slack: '憩流',

  // --- Relative time ---
  just_now: '剛剛',
  somethings_wrong: '發生錯誤',
  hour_ago: '{{hour}} 小時前',
  hours_ago: '{{hour}} 小時前',
  minute_ago: '{{minute}} 分鐘前',
  minutes_ago: '{{minute}} 分鐘前',
  hour_minute_ago: '{{hour}} 小時 {{minute}} 分鐘前',
  hour_minutes_ago: '{{hour}} 小時 {{minute}} 分鐘前',
  hours_minute_ago: '{{hour}} 小時 {{minute}} 分鐘前',
  hours_minutes_ago: '{{hour}} 小時 {{minute}} 分鐘前',
  hour_from_now: '{{hour}} 小時後',
  hours_from_now: '{{hour}} 小時後',
  minute_from_now: '{{minute}} 分鐘後',
  minutes_from_now: '{{minute}} 分鐘後',
  hour_minute_from_now: '{{hour}} 小時 {{minute}} 分鐘後',
  hour_minutes_from_now: '{{hour}} 小時 {{minute}} 分鐘後',
  hours_minute_from_now: '{{hour}} 小時 {{minute}} 分鐘後',
  hours_minutes_from_now: '{{hour}} 小時 {{minute}} 分鐘後',

  // --- Insights ---
  insights_7_day_overview: '7天洞察',
  no_insights_available: '該站點沒有可用的分析。',
  insights_current_extremes: '潮流極值',
  insights_fastest_flood: '最快漲潮',
  insights_fastest_ebb: '最快退潮',
  insights_strongest_daily_currents: '每日峰值潮流',
  insights_fastest_current: '最快',
  insights_slowest_current: '最慢',
  insights_tidal_extremes: '潮汐極值',
  insights_highest_tide: '最高潮位',
  insights_lowest_tide: '最低潮位',
  insights_strongest_daily_movements: '最大潮差範圍',
  insights_largest_tide: '最大',
  insights_smallest_tide: '最小',
  insights_value_at_time: '{{time}} {{value}}',
  insights_tidal_range_label: '潮差',
  insights_max_current_label: '最大潮流',

  // --- Insight bands ---
  band_smaller_than_usual: '小於通常',
  band_typical: '正常',
  band_larger_than_usual: '大於通常',
  band_unusually_large: '異常大',
  band_lower_than_usual: '低於往常',
  band_unusually_low: '異常低',
  band_slower_than_usual: '慢於通常',
  band_faster_than_usual: '快於通常',
  band_unusually_fast: '異常快',
  band_smaller_than_usual_height: '比平常低',
  band_larger_than_usual_height: '比平常高',
  band_unusually_large_height: '異常高',

  // --- Map attribution ---
  attribution: '版權歸屬',
  attribution_osm: '地圖資料 © OpenStreetMap 貢獻者',
  attribution_tiles: '地圖圖磚由 OpenFreeMap 提供',
  attribution_style: '地圖樣式 © OpenMapTiles',
  ok: '確定',

  // --- Explore map ---
  current_speed: '海流速度',
  depth: '水深',
  speed: '航速',
  depth_datum: '深度基準:',
  depth_drying: '乾出',
  depth_loading: '正在載入水深資料…',
  depth_datum_tag: '水深以 {{unit}} 計，基準面 {{datum}}',
  depth_not_for_navigation: '不可用於航行。',
  depth_unavailable: '水深資料暫時無法使用。',
  depth_unit_m: '公尺',
  depth_unit_ft: '英尺',
  go_mode_start: '出發',
  go_mode_start_label: '開始',
  go_mode_exit: '退出',
  go_mode_location_denied: 'Go 模式需要您的位置資訊。請透過鎖定圖示啟用。',
  go_mode_location_denied_ok: '確定',
  radar: '雷達',
  radar_precipitation: '降水',
  radar_light: '小',
  radar_moderate: '中',
  radar_heavy: '大',
  radar_storm: '暴雨',
  radar_forecast: '預報',
  radar_none_for_time: '該時間無雷達資料',
  now: '現在',
  explore_prompt_denied: '本站的位置資訊已關閉：請透過網址列中的鎖定圖示啟用。',
  open_full_map: '開啟完整地圖',
  close_full_map: '關閉完整地圖',
  explore_full_map: '瀏覽完整地圖',
  center_on_location: '定位到我的位置',
  show_my_location: '顯示我的位置',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: '州',
  no_stations_found_location: '找不到站點。',
  tides_and_currents_by_country: '依國家／地區查看潮汐和海流',

  // --- SEO titles / descriptions ---
  settings_seo_description: '選擇潮汐高度和距離的單位。',
  tide_seo_description: '{{name}}{{location}}的潮汐預測、高潮和低潮時間。',
  current_seo_description: '{{name}}{{location}}的海流預測、漲潮和退潮時間。',
  location_title: '{{name}} 潮汐和海流',
  country_seo_description:
    '{{name}}的潮汐時間和海流預測。瀏覽{{name}}各地的{{stateTerm}}和沿海潮汐站。',
  state_seo_description:
    '{{name}}（{{country}}）的潮汐和海流預測。{{name}}沿海站點的高潮和低潮時間。',
  city_seo_description: '{{place}}的潮汐時間和海流預測。{{name}}附近的高低潮汐和海流。',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: '{{name}}的海圖',
  chart_intro:
    '{{title}}的免費海圖。提供實測水深、浮標、立標、礁石、沉船、遊艇碼頭、錨地和潮汐站點。',
  chart_page_name: '{{title}} 海圖',
  chart_seo_description:
    '{{title}}的免費海圖。提供實測水深、浮標、立標、礁石、沉船、遊艇碼頭、錨地和潮汐站點。',

  countries_seo_title: '依國家／地區查看潮汐和海流站',
  countries_seo_description:
    '依國家／地區瀏覽潮汐和海流站。查看全球沿海地點的高低潮時間和海流預報。',
  home_seo_description:
    '查找您附近沿海潮汐站的潮汐時間和海流預測。查看您所在位置的高低潮，或依國家／地區瀏覽潮汐站。',
  explore_play: '播放',
  explore_pause: '暫停',
  explore_playback_speed: '播放速度',
  explore_time: '時間',
  skip_to_content: '跳至主要內容',
  // --- Weather (station pages) ---
  weather: '海洋天氣',
  wind: '風',
  gusts: '陣風',
  seas: '海浪',
  time: '時間',
  air_temp: '氣溫',
  water_temp: '水溫',
  water_temperature: '水溫',
  humidity: '濕度',
  pressure: '氣壓',
  precip_chance: '降水機率',
  chances: '機率',
  precip_rate: '降水強度',
  visibility: '能見度',
  condition_thunderstorms: '雷雨',
  condition_freezing_rain: '凍雨',
  condition_sleet: '雨夾雪',
  condition_snow: '雪',
  condition_fog: '霧',
  condition_rain: '雨',
  condition_cloudy: '陰',
  condition_partly_cloudy: '多雲',
  condition_clear: '晴',
  weather_thunder: '雷',
  note_seas_computed_from_wind: '浪高根據風與海岸線估算。',
  note_seas_from_nearby_open_water: '海況資料來自附近開闊水域。',
  note_seas_open_water_nearby: '附近開闊水域的浪高約為{{height}}。此處可能更平靜。',
  note_seas_open_water_distant: '{{distance}}外開闊水域的浪高約為{{height}}。此處可能更平靜。',
  note_seas_open_water_distant_dir:
    '{{direction}}方向{{distance}}外開闊水域的浪高約為{{height}}。此處可能更平靜。',
  note_seas_unavailable: '此點沒有可靠的海況資料。',
  note_sheltered_water_sees_less: '遮蔽水域的海況通常小於這些開闊水域數值。',
  note_no_warning_feed_coverage: '沒有官方海上警報服務涵蓋此點。',
  note_nearest_point_across_land: '最近的預報點隔著陸地。',
  warnings_none_active: '目前沒有生效的海上警報',
  warnings_unavailable: '此位置無法提供海上警報',
  warning_show_text: '顯示官方原文',
  warning_hide_text: '隱藏官方原文',
  weather_updated: '更新於 {{time}}',
  current_conditions: '目前狀況',
  daily_forecast: '每日預報',
  expand_for_hourly: '展開查看逐小時預報',
  hourly: '每小時',
  hourly_forecast: '逐小時預報',
  wind_speed: '風速',
  wind_gusts: '風及陣風',
  pressure_humidity: '氣壓和濕度',
  max_seas: '最大浪高',
  visibility_excellent: '極佳',
  visibility_good: '良好',
  visibility_moderate: '普通',
  visibility_poor: '較差',
  forecaster_text_link: '{{issuer}} 預報原文',
  temperature: '溫度',
  unit_fahrenheit: '華氏 (°F)',
  unit_celsius: '攝氏 (°C)',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}}～{{end}}',
  warning_window_open: '{{start}}～',
  range_separator_short: '～',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: '週期',
  wave_period_short: '{{period}}秒',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: '北',
  compass_NNE: '北北東',
  compass_NE: '東北',
  compass_ENE: '東北東',
  compass_E: '東',
  compass_ESE: '東南東',
  compass_SE: '東南',
  compass_SSE: '南南東',
  compass_S: '南',
  compass_SSW: '南南西',
  compass_SW: '西南',
  compass_WSW: '西南西',
  compass_W: '西',
  compass_WNW: '西北西',
  compass_NW: '西北',
  compass_NNW: '北北西',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: '小型船隻警報',
  warning_type_gale_warning: '海上大風警報',
  warning_type_gale_watch: '海上大風預警',
  warning_type_storm_warning: '暴風警報',
  warning_type_storm_watch: '暴風預警',
  warning_type_hurricane_force_wind_warning: '颶風級強風警報',
  warning_type_hurricane_force_wind_watch: '颶風級強風預警',
  warning_type_special_marine_warning: '特別海上警報',
  warning_type_marine_weather_statement: '海上天氣通報',
  warning_type_hazardous_seas_warning: '危險海況警報',
  warning_type_brisk_wind_advisory: '較強風力提示',
  warning_type_low_water_advisory: '低水位提示',
  warning_type_dense_fog_advisory: '濃霧提示',
  warning_type_heavy_freezing_spray_warning: '強飛沫結冰警報',
  warning_type_strong_wind_warning: '強風特報',
  warning_type_gale_force_wind_warning: '海上大風警報',
  warning_type_storm_force_wind_warning: '暴風警報',
  warning_type_wind_warning: '海上風警報',
  warning_type_dense_fog_warning: '濃霧警報',
  warning_type_icing_warning: '積冰警報',
  warning_type_typhoon_warning: '海上颱風警報',
  warning_type_wind_wave_warning: '風浪警報',
  warning_type_wind_wave_advisory: '風浪提示',
  warning_type_strong_wind_advisory: '強風提示',
  warning_type_storm_surge_warning: '暴潮警報',
  warning_type_storm_surge_advisory: '暴潮提示',
  warning_type_thunderstorm_warning: '雷暴警報',
  warning_type_rough_sea_warning: '大浪警報',
  warning_type_fog_warning: '濃霧警報',
  sea_state_calm_rippled: '微波',
  sea_state_smooth: '平靜海面',
  sea_state_slight: '輕浪',
  sea_state_moderate: '中浪',
  sea_state_rough: '大浪',
  sea_state_very_rough: '巨浪',
  sea_state_high: '狂浪',
  sea_state_very_high: '狂濤',
  sea_state_phenomenal: '怒濤',
  hazard_showers: '陣雨',
  hazard_reduced_visibility: '能見度差',
  hazard_haze: '輕霧',
  hazard_waterspout: '水龍捲',
  hazard_freezing_spray: '凍霧凇',
  hazard_ice: '結冰',
  marine_summary_sea_wind: '{{sea}}，{{direction}}風 {{speed}}。',
  marine_summary_wind_only_gusting: '{{direction}}風 {{speed}}，陣風 {{gust}}。',
  marine_summary_sea_wind_gusting: '{{sea}}，{{direction}}風 {{speed}}，陣風 {{gust}}。',
  marine_summary_wind_only: '{{direction}}風 {{speed}}。',
  marine_summary_sea_only: '{{sea}}。',
  marine_prediction_caveat_tide_one: '潮汐預報僅為天文潮，該警報中的天氣可能使實際水位升高或降低。',
  marine_prediction_caveat_tide_many:
    '潮汐預報僅為天文潮，這些警報中的天氣可能使實際水位升高或降低。',
  marine_prediction_caveat_current_one:
    '潮流預報僅為天文潮，該警報中的天氣可能使實際流速增強或減弱。',
  marine_prediction_caveat_current_many:
    '潮流預報僅為天文潮，這些警報中的天氣可能使實際流速增強或減弱。',
  marine_warning_active: '本海域發布海上警報。',
  marine_warnings_active: '本海域發布多項海上警報。',
  marine_warning_upcoming: '本海域自{{time}}起發布海上警報。',
  marine_warnings_upcoming: '本海域自{{time}}起發布多項海上警報。',
  marine_summary_hazard_now: '目前有{{hazard}}。',
  marine_summary_hazard_later: '預報有{{hazard}}。',
  marine_tide_rising: '潮位 {{height}}，正在漲潮：下次高潮 {{time}}，{{next}}。',
  marine_tide_falling: '潮位 {{height}}，正在落潮：下次低潮 {{time}}，{{next}}。',
  marine_current_flood: '下次漲潮流 {{time}}，{{speed}}。',
  marine_current_ebb: '下次落潮流 {{time}}，{{speed}}。',
  marine_current_slack: '下次轉流 {{time}}。',
  marine_current_now_flood: '漲潮流 {{speed}}。',
  marine_current_now_ebb: '落潮流 {{speed}}。',
  marine_current_now_slack: '轉流。',
  marine_current_peak: '最強 {{time}}，{{speed}}。',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: '燈標',
  furn_buoy: '浮標',
  furn_beacon: '立標',
  furn_wreck: '沉船',
  furn_rock: '礁石',
  furn_obstruction: '障礙物',
  furn_anchorage: '錨地',
  furn_tss: '分道通航制',
  furn_routing: '航路指定',
  furn_title_buoy: '{{category}}浮標',
  furn_title_beacon: '{{category}}立標',
  furn_cat_port: '左側',
  furn_cat_starboard: '右側',
  furn_cat_preferred_channel_port: '首選航道左側',
  furn_cat_preferred_channel_starboard: '首選航道右側',
  furn_cat_safe_water: '安全水域',
  furn_cat_isolated_danger: '孤立危險物',
  furn_cat_north: '北方位',
  furn_cat_east: '東方位',
  furn_cat_south: '南方位',
  furn_cat_west: '西方位',
  furn_cat_special: '專用',
  furn_cat_mooring: '繫泊',
  furn_cat_lateral: '側面',
  furn_characteristic: '燈質',
  furn_range: '射程',
  furn_height: '高度',
  furn_colour: '顏色',
  furn_shape: '形狀',
  furn_lights_on_mark: '此標誌上的燈光',
  furn_topmark: '頂標',
  furn_class: '類別',
  furn_least_depth_over: '最淺水深',
  furn_depth_over: '上方水深',
  furn_state: '狀態',
  furn_type: '類型',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: '海底電纜',
  furn_pipeline: '海底管線',
  furn_restricted_area: '限制區域',
  furn_restriction: '限制',
  furn_mpa: '海洋保護區',
  furn_protection: '保護級別',
  furn_agency: '管理機構',
  furn_mpa_note: '這是保護區劃定，不是航行限制。',
  furn_sector: '分弧',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: '{{colour}}定光。',
  lightw_fl: '每{{period}}秒{{colour}}閃光一次。',
  lightw_fl_group: '每{{period}}秒{{colour}}群閃（{{count}}次）。',
  lightw_lfl: '每{{period}}秒一次{{colour}}長閃。',
  lightw_q: '{{colour}}急閃。',
  lightw_iso: '明暗等長的{{colour}}等明暗光，週期{{period}}秒。',
  lightw_oc: '每{{period}}秒短暫遮蔽的{{colour}}明暗光。',
  lightcolour_white: '白色',
  lightcolour_red: '紅色',
  lightcolour_green: '綠色',
  lightcolour_yellow: '黃色',
  furn_feet_charted_value: '{{feet}} ft（海圖標註 {{metres}} m）',
  furn_light_yes: '有',
  furn_shown_neutral: '{{colours}}（以中性色顯示）',
  furn_note_light: '燈光在夜間的顯示方式，航海者以此識別。',
  furn_note_lateral_b_port: '標示自海上進港時航道的左側（IALA B：綠色罐形）。',
  furn_note_lateral_b_starboard: '標示自海上進港時航道的右側（IALA B：進港時紅標在右）。',
  furn_note_lateral_a_port: '標示自海上進港時航道的左舷一側（IALA A：左舷為紅）。',
  furn_note_lateral_a_starboard: '標示自海上進港時航道的右舷一側（IALA A：右舷為綠）。',
  furn_note_safe_water: '四周均為安全水域，通常是引航標或航道中央標。',
  furn_note_isolated_danger: '設置在四周可通航水域中的孤立危險物之上。',
  furn_note_cardinal_north: '方位標：請從其北側通過。',
  furn_note_cardinal_east: '方位標：請從其東側通過。',
  furn_note_cardinal_south: '方位標：請從其南側通過。',
  furn_note_cardinal_west: '方位標：請從其西側通過。',
  furn_note_special: '專用標（黃色）：界限、海底電纜、繫泊、比賽等。',
  furn_note_preferred_starboard: '分汊標誌：主航道位於右舷一側。',
  furn_note_preferred_port: '分汊標誌：主航道位於左舷一側。',
  furn_note_mooring: '繫泊浮標。',
  furn_vessel: '船舶',
  furn_depth_quality: '水深品質',
  furn_length: '長度',
  furn_position_accuracy: '定位精度',
  furn_remarks: '備註',
  furn_circumstances: '情況',
  furn_status: '狀態',
  furn_note_shom: '由法國海道測量局（Shom）測繪。©Shom, CC BY-SA 4.0。',
  furn_lock: '船閘',
  furn_bridge: '橋梁',
  furn_overhead_cable: '架空纜線',
  furn_notice_mark: '告示標誌',
  furn_distance_mark: '里程標',
  furn_daymark: '日間標誌',
  furn_channel: '航道',
  furn_vertical_clearance_closed: '垂直淨空（關閉）',
  furn_vertical_clearance_open: '垂直淨空（開啟）',
  furn_datum: '基準面',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    '內河電子航道圖（美國陸軍工兵團）。淨空為上述基準面以上的高度；河水上漲時實際淨空較小。',
  furn_note_wreck: '海圖標註的沉船。水深為海圖值，未經核實。',
  furn_note_anchorage: '海圖標註的錨地。',
  furn_note_tss: '單向航道。小型船舶應垂直穿越並保持避讓。',
  furn_route: '航路',
  furn_fairway: '航道',
  furn_recommended_track: '建議航線',
  furn_navigation_line: '航行線',
  furn_leading_line: '導標線',
  furn_clearing_line: '安全線',
  furn_transit_line: '通航線',
  furn_traffic: '通航',
  furn_orientation: '方位',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: '海圖標繪的航道，為維護或首選的通航水道。',
  furn_note_track: '海圖標繪的航向線。',
  furn_note_track_fixed_marks: '海圖標繪的航向線，以固定標誌（疊標）為基準。',
  furn_note_leading_line: '保持導標疊合，即可沿海圖標繪的線航行。',
  furn_note_navigation_line: '海圖標繪的航行線。',
  furn_poi_marina: '遊艇碼頭',
  furn_poi_fuel: '燃油',
  furn_poi_slipway: '下水滑道',
  furn_poi_ferry_terminal: '渡輪碼頭',
  furn_poi_boatyard: '船廠',
  furn_poi_lighthouse: '燈塔',
  furn_note_slipway: '下水滑道。',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: '跟隨我的朝向',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: 此處無資料',
  ww_row_no_forecast_after: '{{row}}: {{when}}之後無預報',
  ww_row_no_forecast: '{{row}}: 沒有更遠的預報',
  ww_unavailable: '天氣資訊無法使用',
  explore_show_player: '顯示時間軸',
  explore_hide_player: '隱藏時間軸',

  // ROUTE PLANNING on /explore (2026-10-23). Describe, never advise; never
  // "safe". route_disclaimer is only the fallback when the service's response
  // carries no disclaimer of its own.
  route_plan: '規劃航線',
  route_leave: '離開航線規劃',
  route_title: '航線',
  route_prompt_start: '點選你要出發的水面。',
  route_prompt_start_desktop: '按一下你要出發的水面，然後按一下目的地。',
  route_prompt_end: '起點已設定。現在點選目的地。',
  route_prompt_end_desktop: '起點已設定。現在按一下目的地。',
  route_drag_hint: '圖釘可以拖曳。',
  route_clear: '清除',
  route_swap: '對調起點和目的地',
  route_share: '複製連結',
  route_copied: '已複製連結',
  route_start: '起點',
  route_destination: '目的地',
  route_near: '{{name}}附近',
  route_loading: '正在規劃航線…',
  route_loading_sub: '通常只需一兩秒。部分水域最長需要 30 秒。',
  route_loading_slow: '仍在處理…',
  route_loading_slow_sub: '此水域耗時比平常更久。',
  route_summary_time: '{{duration}}（航速 {{speed}}）',
  route_planning_speed: '規劃航速',
  route_shoalest: '航線最淺處',
  route_planning_draft: '規劃吃水',
  route_change: '變更',
  route_draft_title: '規劃吃水',
  route_draft_help:
    '這是規劃航線所用的水深，不是你船的吃水。設得越深，可行航線越少；設得越淺，可行航線越多。',
  route_datum: '水深以海圖基準面（MLLW）為準，未計入潮汐。',
  route_unassured_note: '橘色航段經過海圖和測量無法分辨是否淺於 {{draft}} 的水域。',
  route_row_start: '出發 {{label}}',
  route_row_heading: '航向 {{course}}°（{{point}}）',
  route_row_end: '抵達 {{label}}',
  route_row_end_sub: '航線終點',
  route_turn_left: '左轉至 {{course}}°',
  route_turn_right: '右轉至 {{course}}°',
  route_bear_left: '向左偏轉至 {{course}}°',
  route_bear_right: '向右偏轉至 {{course}}°',
  route_then: '{{first}}，然後{{second}}',
  route_keep_mark: '保持{{mark}}在你的{{hand}}側',
  route_leave_channel: '在{{mark}}處駛離航道',
  route_on_your: '在你的{{hand}}側（{{side}}）',
  route_hand_left: '左',
  route_hand_right: '右',
  route_side_port: '左舷',
  route_side_starboard: '右舷',
  route_mark_buoy: '{{color}}色浮標 {{num}}',
  route_mark_light: '{{color}}色燈標 {{num}}',
  route_mark_daybeacon: '{{color}}色立標 {{num}}',
  route_mark_lighted: '{{mark}}（附燈）',
  route_red: '紅',
  route_green: '綠',
  route_follow: '沿{{name}}航行',
  route_follow_two: '沿{{first}}航行，然後沿{{second}}',
  route_follow_channel: '{{name}}航道',
  route_follow_named: '{{name}}',
  route_follow_unnamed: '有標誌的航道',
  route_follow_marks: '{{count}} 個標誌',
  route_greens_on: '綠標在你的{{hand}}側',
  route_reds_on: '紅標在你的{{hand}}側',
  route_show_marks: '顯示標誌',
  route_hide_marks: '隱藏標誌',
  route_why: '為什麼在這裡轉向？',
  route_turn_reason: '在此轉向的原因：{{reason}}',
  route_lights: '射程內的燈光：{{lights}}',
  route_stretch_unassured: '無法分辨是否淺於 {{draft}}',
  route_stretch_rocky: '位於海圖標繪的礁石之間',
  route_stretch_canal: '運河：未考慮船閘運作、閘門和橋梁淨空',
  route_step_of: '第 {{n}} 步，共 {{total}} 步',
  route_all_steps: '全部步驟',
  route_prev_step: '上一步',
  route_next_step: '下一步',
  route_minutes: '{{n}} 分鐘',
  route_hours: '{{h}} 小時',
  route_hours_minutes: '{{h}} 小時 {{m}} 分鐘',
  route_err_on_land_origin: '起點位於海圖上的陸地',
  route_err_on_land_destination: '目的地位於海圖上的陸地',
  route_err_on_land_origin_sub: '將起點圖釘拖曳到水面上。在海圖上，沼澤、海灘或碼頭都算作陸地。',
  route_err_on_land_destination_sub:
    '將目的地圖釘拖曳到水面上。在海圖上，沼澤、海灘或碼頭都算作陸地。',
  route_err_no_route: '規劃吃水 {{draft}} 時沒有可行航線',
  route_err_no_route_sub: '兩點之間某處的海圖水深淺於 {{draft}}。減小規劃吃水或許能找到航線。',
  route_err_no_snap: '其中一個點附近沒有海圖標繪的水域',
  route_err_no_snap_sub: '將圖釘移到更靠近開闊水域的位置。',
  route_err_outside: '航線規劃目前僅涵蓋美國水域',
  route_err_outside_sub: '航線依據 NOAA 海圖產生，因此兩個點都必須位於美國水域。更多海岸稍後推出。',
  route_err_timeout: '航線服務回應逾時',
  route_err_timeout_sub: '部分水域最長需要 30 秒，此次已逾時。',
  route_err_unavailable: '航線規劃目前無法使用',
  route_err_unavailable_sub: '請稍後再試。',
  route_err_busy: '航線請求過多',
  route_err_busy_sub: '請等候一分鐘後再試。',
  route_try_again: '再試一次',
  route_disclaimer: '不可用於航行。此航線沿海圖標繪的有標誌航道；這並非聲明該水域安全。',
  route_promo_title: '在應用程式中用 Go Mode 跟隨此航線',
  route_promo_body:
    'Go Mode 會在海圖上持續顯示你的船，並顯示到下一個標誌或轉向點的距離、船下水深，以及最近測站的潮汐和潮流。適用於 iPhone 和 Android 版「潮汐在身邊」，需訂閱。',
}
